<template>
  <main class="ws-login-screen">
    <section
      class="ws-login-visual"
      style="background-image: url('/static/img/background/background-2.jpg')"
      aria-label="Weesam Express harbor"
    >
      <div class="ws-login-brand">
        <span class="ws-login-brand-dot"></span>
        <span>Weesam Express · Ticket Shipper</span>
      </div>

      <div class="ws-login-visual-copy">
        <p class="ws-login-kicker">
          <span class="ws-login-rule"></span>
          The day starts at the water
        </p>
        <h2>Every crossing begins with you.</h2>
        <p class="ws-login-visual-caption">
          <span class="ws-login-caption-rule"></span>
          A smoother passage, from the very first ticket.
        </p>
      </div>

      <div class="ws-login-visual-meta">
        <span class="ws-login-brand-dot"></span>
        Harbor operations
      </div>
    </section>

    <section class="ws-login-panel" aria-labelledby="ws-login-title">
      <div class="ws-login-access">
        <span class="ws-login-access-dot"></span>
        Staff access
      </div>

      <div class="ws-login-content">
        <img
          class="ws-login-logo"
          src="@/assets/images/app_logo.png"
          alt="Weesam Express"
        >

        <div class="ws-login-intro">
          <p class="ws-login-eyebrow">Ticket Shipper portal</p>
          <h1 id="ws-login-title">Welcome aboard.</h1>
          <p class="ws-login-description">
            Sign in to prepare tickets and keep every voyage moving.
          </p>
        </div>

        <form class="ws-login-form" @submit.prevent="login" novalidate>
          <div v-if="message" class="ws-login-alert" role="alert" aria-live="assertive">
            <svg viewBox="0 0 20 20" fill="none" aria-hidden="true">
              <circle cx="10" cy="10" r="7.2"></circle>
              <path d="M10 6.4v4.2m0 2.8h.01"></path>
            </svg>
            <span>{{ message }}</span>
          </div>

          <div class="ws-login-field">
            <label for="ws-login-identity">Username or email</label>
            <div class="ws-login-input-wrap">
              <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <circle cx="12" cy="8" r="3.4"></circle>
                <path d="M4.8 20c.55-3.55 3.28-5.55 7.2-5.55s6.65 2 7.2 5.55"></path>
              </svg>
              <input
                id="ws-login-identity"
                v-model="form.email"
                type="text"
                autocomplete="username"
                placeholder="Enter your username or email"
              >
            </div>
          </div>

          <div class="ws-login-field">
            <label for="ws-login-password">Password</label>
            <div class="ws-login-input-wrap">
              <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <rect x="4.6" y="10" width="14.8" height="10.2" rx="2"></rect>
                <path d="M8 10V7.1a4 4 0 1 1 8 0V10"></path>
                <path d="M12 14v2.2"></path>
              </svg>
              <input
                id="ws-login-password"
                v-model="form.password"
                type="password"
                autocomplete="current-password"
                placeholder="Enter your password"
              >
            </div>
          </div>

          <button
            class="ws-login-submit"
            type="submit"
            :disabled="loading"
            :aria-busy="loading"
          >
            <span>{{ loading ? 'Signing you in…' : 'Sign in to your account' }}</span>
            <span v-if="loading" class="ws-login-spinner" aria-hidden="true"></span>
            <svg v-else viewBox="0 0 20 20" fill="none" aria-hidden="true">
              <path d="M3.5 10h12m-4.5-4.5L15.5 10 11 14.5"></path>
            </svg>
          </button>
        </form>

        <div class="ws-login-links">
          <a href="/forgot-password">Forgot password?</a>
          <span>Secure staff sign-in</span>
        </div>

        <div class="ws-login-footer">
          <span>Weesam Express <i>/</i> Ticket Shipper</span>
          <p>A steady hand on every departure.</p>
        </div>
      </div>
    </section>
  </main>
</template>
<script>
  import { Authenticate } from '@/resources/authenticate'

  export default {
    created: function() {
    },
    methods: {
      toggleNavbar() {
        document.body.classList.toggle('nav-open')
      },
      closeMenu() {
        document.body.classList.remove('nav-open')
        document.body.classList.remove('off-canvas-sidebar')
      },
      goToRegister() {
        this.$router.push({ name: 'Register' })
      },
      login() {
        var self = this
        this.loading = true
        Authenticate.login(this.form, function(user, message, extraError){
          if (user) {
            let redirect = self.$route.query.redirect
            if (redirect) {
              self.$router.push(redirect)
            } else {
               self.$router.push({ name: 'Home', query: {login: true} })
            }
          } else {
            self.showAlert(message)
          }
          self.loading = false
          self.error = extraError
        })
      },
       showAlert(message) {
      this.message = message
      let vm = this
      setTimeout(function () { vm.message = null }, 5000)
    },
  },
   
    data() {
      return {
        form: {
          email: '',
          password: ''
        },
        loading: false,
        message: null,
        error: null
      }
    },
    beforeDestroy() {
      this.closeMenu()
    }
  }
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Instrument+Serif&display=swap');

.ws-login-screen,
.ws-login-screen * {
  box-sizing: border-box;
}

.ws-login-screen {
  display: grid;
  grid-template-columns: minmax(0, 1.04fr) minmax(390px, 0.96fr);
  min-height: 100vh;
  min-height: 100dvh;
  overflow: hidden;
  color: #18394b;
  background: #f3f1e9;
  font-family: 'Montserrat', 'Muli', 'Helvetica Neue', Arial, sans-serif;
}

.ws-login-visual {
  position: relative;
  min-height: 100vh;
  min-height: 100dvh;
  overflow: hidden;
  isolation: isolate;
  background-color: #17465b;
  background-position: 64% center;
  background-size: cover;
  background-repeat: no-repeat;
}

.ws-login-visual::after {
  position: absolute;
  z-index: -1;
  inset: 0;
  content: '';
  background: linear-gradient(0deg, rgba(12, 41, 59, 0.86), rgba(12, 41, 59, 0.08) 72%);
}

.ws-login-brand,
.ws-login-visual-copy,
.ws-login-visual-meta {
  position: absolute;
  z-index: 1;
  color: #fff;
}

.ws-login-brand {
  top: 36px;
  left: 40px;
  display: flex;
  align-items: center;
  gap: 11px;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.22em;
  text-transform: uppercase;
}

.ws-login-brand-dot,
.ws-login-access-dot {
  flex: 0 0 auto;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #24d5da;
}

.ws-login-brand-dot {
  box-shadow: 0 0 0 4px rgba(36, 213, 218, 0.18);
}

.ws-login-visual-copy {
  right: 12%;
  bottom: 9.5%;
  left: 10%;
}

.ws-login-kicker,
.ws-login-visual-caption {
  display: flex;
  align-items: center;
  gap: 9px;
  margin: 0;
  text-transform: uppercase;
}

.ws-login-kicker {
  margin-bottom: 16px;
  color: #9de6e7;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.2em;
}

.ws-login-rule,
.ws-login-caption-rule {
  display: inline-block;
  flex: 0 0 auto;
  height: 1px;
}

.ws-login-rule {
  width: 28px;
  background: #ef4a49;
}

.ws-login-visual-copy h2 {
  max-width: 560px;
  margin: 0;
  color: #fff;
  font-family: 'Instrument Serif', Georgia, 'Times New Roman', serif;
  font-size: clamp(48px, 5.1vw, 76px);
  font-weight: 400;
  letter-spacing: -0.025em;
  line-height: 0.98;
}

.ws-login-visual-caption {
  margin-top: 20px;
  color: rgba(255, 255, 255, 0.82);
  font-size: 10px;
  letter-spacing: 0.08em;
  text-transform: none;
}

.ws-login-caption-rule {
  width: 36px;
  background: rgba(255, 255, 255, 0.55);
}

.ws-login-visual-meta {
  right: 32px;
  bottom: 24px;
  display: flex;
  align-items: center;
  gap: 9px;
  color: rgba(255, 255, 255, 0.75);
  font-size: 9px;
  letter-spacing: 0.18em;
  text-transform: uppercase;
}

.ws-login-visual-meta .ws-login-brand-dot {
  width: 6px;
  height: 6px;
  box-shadow: none;
}

.ws-login-panel {
  position: relative;
  display: flex;
  min-height: 100vh;
  min-height: 100dvh;
  align-items: center;
  justify-content: center;
  padding: 64px clamp(36px, 6vw, 96px);
  background: #f3f1e9;
}

.ws-login-access {
  position: absolute;
  top: 36px;
  right: clamp(24px, 6vw, 88px);
  display: inline-flex;
  align-items: center;
  gap: 9px;
  padding: 8px 13px;
  border: 1px solid #d7d9d1;
  border-radius: 999px;
  color: #647a7e;
  background: #f8f7f1;
  font-size: 9px;
  font-weight: 600;
  letter-spacing: 0.17em;
  text-transform: uppercase;
}

.ws-login-access-dot {
  width: 6px;
  height: 6px;
  background: #d94744;
}

.ws-login-content {
  width: 100%;
  max-width: 420px;
  margin: auto;
}

.ws-login-logo {
  display: block;
  width: 186px;
  max-width: 100%;
  height: auto;
  margin: 0 0 42px;
  object-fit: contain;
}

.ws-login-intro {
  margin-bottom: 27px;
}

.ws-login-eyebrow {
  margin: 0 0 12px;
  color: #168f9c;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.21em;
  text-transform: uppercase;
}

.ws-login-intro h1 {
  margin: 0;
  color: #17394b;
  font-family: 'Instrument Serif', Georgia, 'Times New Roman', serif;
  font-size: 50px;
  font-weight: 400;
  letter-spacing: -0.025em;
  line-height: 0.98;
}

.ws-login-description {
  max-width: 340px;
  margin: 16px 0 0;
  color: #627579;
  font-size: 14px;
  line-height: 1.7;
}

.ws-login-form {
  display: flex;
  flex-direction: column;
  gap: 19px;
}

.ws-login-alert {
  display: flex;
  align-items: flex-start;
  gap: 11px;
  padding: 12px 14px;
  border-left: 3px solid #d94b45;
  color: #8b3936;
  background: #fae9e4;
  font-size: 13px;
  line-height: 1.5;
}

.ws-login-alert svg {
  width: 16px;
  height: 16px;
  flex: 0 0 auto;
  margin-top: 2px;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-width: 1.5;
}

.ws-login-alert svg path {
  stroke-width: 1.7;
}

.ws-login-field label {
  display: block;
  margin: 0 0 8px;
  color: #385965;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.025em;
}

.ws-login-input-wrap {
  display: flex;
  min-height: 52px;
  align-items: center;
  gap: 12px;
  padding: 0 15px;
  border: 1px solid #d5d9d3;
  background: #f8f7f1;
  transition: border-color 160ms ease, box-shadow 160ms ease;
}

.ws-login-input-wrap:focus-within {
  border-color: #168f9c;
  box-shadow: 0 0 0 3px rgba(22, 143, 156, 0.14);
}

.ws-login-input-wrap svg {
  width: 18px;
  height: 18px;
  flex: 0 0 auto;
  stroke: #789094;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.6;
}

.ws-login-input-wrap input {
  width: 100%;
  min-width: 0;
  height: 50px;
  padding: 0;
  border: 0;
  outline: 0;
  color: #18394b;
  background: transparent;
  font: 13px 'Montserrat', 'Muli', 'Helvetica Neue', Arial, sans-serif;
}

.ws-login-input-wrap input::placeholder {
  color: #9aa9a8;
  opacity: 1;
}

.ws-login-submit {
  display: flex;
  width: 100%;
  min-height: 54px;
  align-items: center;
  justify-content: space-between;
  margin-top: 2px;
  padding: 0 20px;
  border: 0;
  color: #fff;
  background: #15516a;
  cursor: pointer;
  font: 700 11px 'Montserrat', 'Muli', 'Helvetica Neue', Arial, sans-serif;
  letter-spacing: 0.14em;
  text-align: left;
  text-transform: uppercase;
  transition: background 160ms ease, opacity 160ms ease;
}

.ws-login-submit:hover:not(:disabled) {
  background: #103f54;
}

.ws-login-submit:focus-visible {
  outline: 2px solid #168f9c;
  outline-offset: 3px;
}

.ws-login-submit:disabled {
  cursor: wait;
  opacity: 0.76;
}

.ws-login-submit svg {
  width: 16px;
  height: 16px;
  flex: 0 0 auto;
  stroke: #64d2d3;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.6;
}

.ws-login-spinner {
  width: 16px;
  height: 16px;
  flex: 0 0 auto;
  border: 2px solid rgba(255, 255, 255, 0.9);
  border-top-color: transparent;
  border-radius: 50%;
  animation: ws-login-spin 700ms linear infinite;
}

@keyframes ws-login-spin {
  to { transform: rotate(360deg); }
}

.ws-login-links {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-top: 19px;
}

.ws-login-links a {
  color: #277f89;
  font-size: 12px;
  font-weight: 600;
  text-decoration: underline;
  text-decoration-color: #a5c6c1;
  text-underline-offset: 4px;
}

.ws-login-links a:hover {
  color: #15516a;
}

.ws-login-links a:focus-visible {
  border-radius: 2px;
  outline: 2px solid #168f9c;
  outline-offset: 3px;
}

.ws-login-links span {
  color: #879897;
  font-size: 10px;
}

.ws-login-footer {
  margin-top: 45px;
  padding-top: 18px;
  border-top: 1px solid #d8d9d1;
  color: #879391;
  font-size: 10px;
  letter-spacing: 0.035em;
  line-height: 1.8;
}

.ws-login-footer span {
  font-weight: 500;
  text-transform: uppercase;
}

.ws-login-footer i {
  padding: 0 4px;
  color: #c3c6bc;
  font-style: normal;
}

.ws-login-footer p {
  margin: 5px 0 0;
}

@media (max-width: 879px) {
  .ws-login-screen {
    display: block;
    overflow: visible;
  }

  .ws-login-visual {
    min-height: 220px;
    height: 220px;
  }

  .ws-login-brand {
    top: 25px;
    left: 24px;
    font-size: 8px;
    letter-spacing: 0.17em;
  }

  .ws-login-visual-copy {
    right: 24px;
    bottom: 17px;
    left: 24px;
  }

  .ws-login-kicker {
    margin-bottom: 8px;
    font-size: 8px;
  }

  .ws-login-visual-copy h2 {
    max-width: 440px;
    font-size: 34px;
  }

  .ws-login-visual-caption {
    margin-top: 11px;
    font-size: 9px;
  }

  .ws-login-visual-meta {
    display: none;
  }

  .ws-login-panel {
    min-height: 0;
    padding: 38px 32px 58px;
  }

  .ws-login-access {
    top: 20px;
    right: 24px;
    padding: 7px 10px;
    font-size: 8px;
  }

  .ws-login-content {
    max-width: 420px;
  }

  .ws-login-logo {
    width: 160px;
    margin-bottom: 24px;
  }

  .ws-login-intro {
    margin-bottom: 22px;
  }

  .ws-login-intro h1 {
    font-size: 43px;
  }

  .ws-login-description {
    margin-top: 11px;
    font-size: 13px;
  }

  .ws-login-form {
    gap: 16px;
  }

  .ws-login-input-wrap {
    min-height: 48px;
  }

  .ws-login-input-wrap input {
    height: 46px;
  }

  .ws-login-submit {
    min-height: 52px;
  }

  .ws-login-footer {
    margin-top: 34px;
    display: none;
  }
}

@media (max-width: 420px) {
  .ws-login-panel {
    padding-right: 24px;
    padding-left: 24px;
  }

  .ws-login-description {
    max-width: 310px;
  }

  .ws-login-links {
    gap: 10px;
  }
}
</style>
